
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/lakebase",
      function () {
        return require("private-next-pages/sources/lakebase.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/lakebase"])
      });
    }
  